export enum KnownConsentIdentifiers {
  LingoKingAddOnService = "LingoKingAddOnService",
  OrganisationConsentBarmerHealthCare = "OrganisationConsentBarmerHealthCare",
  OrganizationConsentStarnormInsurances = "OrganizationConsentStarnormInsurances",
  OrganisationConsentChatCometChat = "OrganisationConsentChatCometChat",
  GeneralBrokerMandateCandidate = "GeneralBrokerMandateCandidate",
  GeneralBrokerMandateOrganization = "GeneralBrokerMandateOrganization",
  GeneralTermsAndConditions = "GeneralTermsAndConditions",
  // deprecated, use GeneralBrokerMandateCandidate instead
  // kept here to be able to query old consents
  deprecated_CandidateConsentBarmerHealthCare = "CandidateConsentBarmerHealthCare",
  AnkaadiaDocumentExtractionConsent = "AnkaadiaDocumentExtractionConsent",
  AnkaadiaCvParsingConsent = "AnkaadiaCvParsingConsent",
  TalentPoolEmployerPoolService = "TalentPoolEmployerPoolService",
  TalentPoolPSAPoolService = "TalentPoolPSAPoolService",
  TalentPoolWebsiteService = "TalentPoolWebsiteService",
  DocuSealDocumentSigningService = "DocuSealDocumentSigningService",
}
